<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>Dina meddelanden</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    @for (m of messages; track $index) {
      <spb-list-item [message]="m"></spb-list-item>
    } @empty {
      <mat-progress-bar mode="buffer"></mat-progress-bar>
    }
  </mat-card-content>
</mat-card>

